const jhonData = {
  name: "Kennedy",
  // name2: "Richard Tea.",
  // name3: "Alexa Johnson",
  role: "Software Engineer,",
  ptext: "Creative Designer & Developer located in London.",
  socialLinks: [
    {
      name: "Facebook",
      url: "https://www.facebook.com/dumebi.ohiri",
      className: "social_facebook",
    },
    {
      name: "Linkedin",
      url: "https://www.linkedin.com/in/ohiri-chidumebi-474667182/",
      className: "social_linkedin",
    },
    // {
    //   name: "Github",
    //   url: "https://github.com/DennekJr",
    //   className: "fab fa-github",
    // },
  ],
  aboutme: "About Me",
  aboutdetails:
    "I am Kennedy, a full-stack software engineer building and supporting education, fleet-management, events and investment platforms. I work across user interfaces, backend services and application operations, turning business workflows into maintainable systems.",
  service: [
    {
      id: 1,
      iconName: "icon-desktop",
      serviceTitle: "Frontend Engineering",
      sDetails:
        "I build responsive customer and administrative applications with React, Next.js, TypeScript and JavaScript, supported by Redux Toolkit and Tailwind CSS.",
    },
    {
      id: 2,
      iconName: "icon-pencil",
      serviceTitle: "Full-Stack Development",
      sDetails:
        "I deliver full-stack platforms across EduTrace and LiveLabs, connecting React and Next.js interfaces to Node.js, NestJS and Express APIs, with Prisma, PostgreSQL and MongoDB.",
    },
    {
      id: 3,
      iconName: "icon-presentation",
      serviceTitle: "Security & Integrity",
      sDetails:
        "I implement role-based access, scoped data, authentication and audit trails, with QR and OTP workflows that protect delivery and inventory integrity.",
    },
    {
      id: 4,
      iconName: "icon-linegraph",
      serviceTitle: "Application Operations",
      sDetails:
        "I support deployments, CI/CD and production troubleshooting across Vercel, Railway, Heroku and Cloudflare, including Docker, database migrations and domain configuration.",
    },
    // {
    //   id: 5,
    //   iconName: "icon-gears",
    //   serviceTitle: "Support",
    //   sDetails:
    //     "There are many variations of pssages of Lorm available, bu in some form, Lorem Ipsum is simply dummy text.",
    // },
    {
      id: 6,
      iconName: "icon-tools",
      serviceTitle: "Integrations & Testing",
      sDetails:
        "I integrate payments, authentication and email services with Paystack, Stripe and Firebase, and use Jest and React Testing Library to verify workflows and access rules.",
    },
  ],
  contact: [
    {
      id: "1",
      title: "Contact Info",
      menuItems: [
        {
          id: 1,
          icon: "icon_pin_alt",
          text: "Address: Lagos State. Nigeria",
        },
        {
          id: 2,
          icon: "icon_phone",
          text: "Phone: +234 9130761936",
        },
        {
          id: 3,
          icon: "icon_mail",
          text: "Email: ohirikennedy@yahoo.com",
        },
        {
          id: 4,
          icon: "social_linkedin",
          text: "https://www.linkedin.com/in/ohiri-chidumebi-474667182/",
        },
      ],
    },
  ],
  devloperBanner: [
    {
      id: 1,
      subtile: "Front-End Developer",
      title: "Talk is cheap. \n Show me the code",
      discription:
        "I take pride in tackling increasingly difficult problems above my skill set to help promote growth",
    },
  ],
  devAbout: [
    {
      id: 1,
      smalltitle: "Introduce",
      aHead: "Passion \n Heart & Soul",
      aHeadTwo: "Every great design begins with an even better story",
      adiscription:
        "Since beginning my journey as a freelancer developer nearly 4 years ago, I've done remote work for agencies, consulted for startups, and collaborated with talented people to create digital products for both business and consumer use, I am confident, naturally curious.",
    },
  ],
  aboutSkill: [
    {
      id: 1,
      workName: "Design",
      text: "Create digital products with a unique idea",
      complateProject: "20 Projects",
      icon: "icon-tools",
    },
    {
      id: 2,
      workName: "front-End",
      text: "My coding structure is clean and smooth",
      complateProject: "165 Projects",
      icon: "icon-genius",
    },
    {
      id: 3,
      workName: "SEO",
      text: "Boost your business with SEO optimization.",
      complateProject: "5 Projects",
      icon: "icon-linegraph",
    },
  ],
  awards: [
    {
      id: 1,
      image: "logo1.png",
      ctile: "Site of the year 2020",
      date: "April 2020",
      description: "For most favorited design voted by NY City Style customers",
      url: "http://www.pinterest.com",
      linktext: "view More",
    },
    {
      id: 2,
      image: "logo2.png",
      ctile: "Theme of the day 2021",
      date: "March 2021",
      description: "For most favorited design voted by NY City Style customers",
      url: "http://www.pinterest.com",
      linktext: "view More",
    },
    {
      id: 3,
      image: "logo2.png",
      ctile: "Best design awwards",
      date: "March 2021",
      description: "For most favorited design voted by NY City Style customers",
      url: "http://www.pinterest.com",
      linktext: "view More",
    },
  ],
  contacttitle: "Contact Form",
};

export default jhonData;
